/* eslint-disable max-lines */

export enum CommonIcons {
  exclamation = 'exclamationIcon',
  more = 'moreIcon',
  action = 'action',
  telematicsIcon = 'telematicsIcon',
  telematicsStatus='telematicsStatus',
  moreIconDisabled = '/assets/moreIconDisabled.svg'
}
export enum UserStatus {
  active = 'active',
  inactive = 'inactive',
  pending = 'pending',
  failed = 'failed',
  ssoFailure = 'ssoFailure'
}

export enum LanguageCode {
  default = 'en-US'
}

export enum DateFormat {
  default = 'MM/dd/yyyy'
}
export enum SortOrder {
  desc = 'desc',
  asc = 'asc',
}
export enum Notifications {
  all = 'All',
  offer = 'Offer',
  update = 'Update',
  action = 'Action',
  unread = 'unread',
  archived = 'archived',
  read = 'read'

}

export enum CountryCode {
  unitedStates ='US',
  canada = 'CA',
  unitedStatesofAmerica = 'USA',
  canadaCountry = 'CAN',
  unitedStatesFull = 'UNITED STATES',
  canadaFull = 'CANADA'
}

export enum RemovalReasons {
  scrapped = 'Scrap',
  stolen = 'Stolen',
  sold = 'Sold / Off Lease',
  exported = 'Exported out of US/Canada',
  removeReviewComment = 'Customer removed from Parking Lot',
}

export enum CancelEquipmentButtons {
  no = 'No',
  yes = 'Yes'
}

export enum RemovalSubmissionButton {
  submit = 'Submit',
  cancel = 'Cancel',
  yesSubmit = 'Yes, Submit',
  proceed = 'Proceed',
  confirm = 'Confirm'
}

export enum CssClass {
  btnSecondary = 'btn-secondary',
  btnBlack = 'btn-black',
  btnDanger = 'btn-danger',
  removeEquipmentTitle = 'removeEquipmentTitle',
  confirmEquipmentTitle = 'confirmEquipmentTitle',
  cancelRemoveEquipment = 'cancelRemoveEquipment',
  confirmRemoveEquipment = 'confirmRemoveEquipment',
  successErrorRemoveEquipment = 'successErrorRemoveEquipment',
  addTruckSuccessFailure = 'addTruckSuccessFailure',
  registerModal = 'register-modal',
  confirmRemoveLocation = 'confirmRemoveLocation',
  removeLocationTitle = 'removeLocationTitle',
  successErrorRemoveCompanyLocation = 'successErrorRemoveCompanyLocation',
  termsAndCondition = 'termsAndCondition',
  addNewLocationMsg = 'addNewLocationMsg',
  addNewEquipment = 'addNewEquipment',
  moveTruckSuccessFailure = 'moveTruckSuccessFailure',
  errorBusinessSection='error-business-section',
  businessRegistrationSubmitModalTitle = 'businessRegistrationSubmitModalTitle',
  businessRegistrationUploadModal='businessRegistrationUploadModal',
  uploadFileTitle = 'uploadFileTitle',
  vertexVerificationModal = 'vertexVerificationModal',
  companyNotFoundModal = 'companyNotFoundModal',
  severityStatusIcon = 'severity-dot-icon',
  subscriptionAddressModal = 'subscription-modals',
  cancelRenewalModal = 'cancel-renewal',
  subscriptionTableHeader = 'subscription-table-header',
  confirmDefaultView = 'confirm-default-view',
  confirmNewDefaultView = 'confirm-new-default-view',
  operatorHourHeader = 'operator-hour-header'
}

export enum ConfirmRemovalButton {
  removeEquipment = 'Remove Equipment',
  cancel = 'Cancel',
}

export enum EquipmentButtons {
  removeEquipment = 'Remove Equipment',
  moveEquipment = 'Move Equipment'
}

export enum FileName {
  myfleet = 'MyFleet',
  userManagement = 'UserManagement',
  orderManagement = 'EquipmentOrderList',
  serviceManagement = 'Servicehistory',
  companyLocations = 'CompanyLocations',
  assignUserList= 'UserList',
  userLocationListUploadTemplate='ToyotaMaterialHandelling',
  inviteUserTemplate='Invite_Users_Template',
  addBulkEquipmentTemplate='Add_Bulk_Equipment_Template',
  myQuotesList = 'QuoteManagement',
  connectedEquipmentList = 'ConnectedEquipmentList',
  bulkequipmentReport = 'bulk_equipment_report',
  addBulkEquipmentToyotaDownloadReportTemplate = 'Add_Bulk_Equipment_Toyota_Download_Report_Template',
  addBulkEquipmentNonToyotaDownloadReportTemplate = 'Add_Bulk_Equipment_NonToyota_Download_Report_Template',
  addBulkLocationTemplate = 'Location_Bulk_Upload',
  analyticsFileName = 'Download',
  reviewListDownloadtemplate = 'review_list-download-template',
  sitePerformance = 'LocationPerformers',
  allSubscriptionList = 'AllSubscription_List',
  subscriptionAddressList = 'Subscription_Address_List',
  addBulkEquipmentRaymondDownloadReportTemplate = 'Add_Bulk_Equipment_Raymond_Download_Report_Template',
  addBulkEquipmentNonRaymondDownloadReportTemplate = 'Add_Bulk_Equipment_NonRaymond_Download_Report_Template',
}

export enum ConfirmLeavePageButtons {
  stay = 'Stay on Page',
  leave = 'Leave Page'
}
export enum FilterOptions {
  location = 'Location',
  division = 'Division',
  group = 'Group',
  dateRange = 'Date Range',
  repairType = 'Repair Type',
  equipmentType = 'Equipment Type',
  equipmentClassification = 'Equipment Classification',
  status = 'Status',
  changeRequestType = 'Change Request Type',
  assignedLoc = 'Assigned Location',
  dateRangeMyFleet = 'Date Of First Use',
  telematicStatus = 'Telematic Status',
  role = 'Role',
  billingAddress = 'Billing Address',
  billingLocation = 'Billing Location',
  shippingLocation = 'Shipping Location',
  customDateRange = 'Custom Date Range',
  serviceAddress = 'Service Address',
  shippingAddress = 'Shipping Address',
  assetType = 'Asset Type',
  term = 'Term'
}
export enum OrderStatus {
  production = 'Unit in production',
  quality = 'Quality inspection completed',
  awaitingDealer = 'Unit awaiting shipment to dealer',
  order = 'Order Confirmed',
  orderProcess = 'Order in Process',
  scheduledProd = 'Scheduled for Production',
  unit = 'Unit shipped to dealer',
  delivery = 'Unit at dealership, awaiting delivery',
  delivered = 'Unit delivered',
  cancelled = 'Cancelled',
  orderProduction = 'In Production',
  shipped = 'Shipped',
  deliverStatus = 'Delivered',
  estimateDate = 'Estimated Delivery Date'
}
export enum MobileAssignedUsers {
 name = 'Name',
 email = 'Email',
 role = 'Role',
 jobTitle = 'Job Title',
 status = 'Status'

}
export enum ExpansionCondition {
  showMore = 'Show More',
  showLess = 'Show Less',
  viewMore = 'View More',
}

export enum BulkEquipmentTabLabels {
  addEquipment = 'Add Equipment',
  bulkEquipment = 'Upload Equipment',
  uploadLimitText = 'Upload Limit :',

}

export enum SuccessFailureBtn {
  close = 'Close',
  addEqp = 'Add Another Equipment',
  addNewEqp = 'Add',
  confirmLocation = 'Confirm'
}
export const countries: {label: string; value: string}[] = [
	{ label: 'Canada', value: 'CAN' },
	{ label: 'United States', value: 'USA' }
];
export const states: {label: string; value: string}[] = [
	{ label: 'Alabama', value: 'AL' },
	{ label: 'Alaska', value: 'AK' },
	{ label: 'American Samoa', value: 'AS' },
	{ label: 'Arizona', value: 'AZ' },
	{ label: 'Arkansas', value: 'AR' },
	{ label: 'California', value: 'CA' },
	{ label: 'Colorado', value: 'CO' },
	{ label: 'Connecticut', value: 'CT' },
	{ label: 'Delaware', value: 'DE' },
	{ label: 'District of Columbia', value: 'DC' },
	{ label: 'Florida', value: 'FL' },
	{ label: 'Georgia', value: 'GA' },
	{ label: 'Guam', value: 'GU' },
	{ label: 'Hawaii', value: 'HI' },
	{ label: 'Idaho', value: 'ID' },
	{ label: 'Illinois', value: 'IL' },
	{ label: 'Indiana', value: 'IN' },
	{ label: 'Iowa', value: 'IA' },
	{ label: 'Kansas', value: 'KS' },
	{ label: 'Kentucky', value: 'KY' },
	{ label: 'Louisiana', value: 'LA' },
	{ label: 'Maine', value: 'ME' },
	{ label: 'Maryland', value: 'MD' },
	{ label: 'Massachusetts', value: 'MA' },
	{ label: 'Michigan', value: 'MI' },
	{ label: 'Minnesota', value: 'MN' },
	{ label: 'Mississippi', value: 'MS' },
	{ label: 'Missouri', value: 'MO' },
	{ label: 'Montana', value: 'MT' },
	{ label: 'Nebraska', value: 'NE' },
	{ label: 'Nevada', value: 'NV' },
	{ label: 'New Hampshire', value: 'NH' },
	{ label: 'New Jersey', value: 'NJ' },
	{ label: 'New Mexico', value: 'NM' },
	{ label: 'New York', value: 'NY' },
	{ label: 'North Carolina', value: 'NC' },
	{ label: 'North Dakota', value: 'ND' },
	{ label: 'Ohio', value: 'OH' },
	{ label: 'Oklahoma', value: 'OK' },
	{ label: 'Oregon', value: 'OR' },
	{ label: 'Pennsylvania', value: 'PA' },
	{ label: 'Puerto Rico', value: 'PR' },
	{ label: 'Rhode Island', value: 'RI' },
	{ label: 'South Carolina', value: 'SC' },
	{ label: 'South Dakota', value: 'SD' },
	{ label: 'Tennessee', value: 'TN' },
	{ label: 'Texas', value: 'TX' },
	{ label: 'Utah', value: 'UT' },
	{ label: 'Vermont', value: 'VT' },
	{ label: 'Virginia', value: 'VA' },
	{ label: 'Virgin Islands', value: 'VI' },
	{ label: 'Washington', value: 'WA' },
	{ label: 'West Virginia', value: 'WV' },
	{ label: 'Wisconsin', value: 'WI' },
	{ label: 'Wyoming', value: 'WY' }
];
export const provinces = [
	{ label: 'Alberta', value: 'AB' },
	{ label: 'British Columbia', value: 'BC' },
	{ label: 'Manitoba', value: 'MB' },
	{ label: 'New Brunswick', value: 'NB' },
	{ label: 'Newfoundland and Labrador', value: 'NL' },
	{ label: 'Northwest Territories', value: 'NT' },
	{ label: 'Nova Scotia', value: 'NS' },
	{ label: 'Nunavut', value: 'NU' },
	{ label: 'Ontario', value: 'ON' },
	{ label: 'Prince Edward Island', value: 'PE' },
	{ label: 'Quebec', value: 'QC' },
	{ label: 'Saskatchewan', value: 'SK' },
	{ label: 'Yukon', value: 'YT' }
];

export const jobTitle =  [
	{ label: 'Purchasing', value: '02' },
	{ label: 'Finance/Accounting', value: '09' },
	{ label: 'Maintenance Manager', value: 'MM' },
	{ label: 'Operations Manager', value: 'OM' },
	{ label: 'Safety Mgmt', value: 'XD' },
	{ label: 'Plant Manager', value: 'Z1' },
	{ label: 'President/CEO', value: 'Z4' },
	{ label: 'Engineering Mgmt', value: 'Z7' },
	{ label: 'Fleet & Maint. Mgmt', value: 'ZF' },
	{ label: 'General Manager', value: 'ZG' },
	{ label: 'Logistics/SupplyChain', value: 'ZL' },
	{ label: 'Manager', value: 'ZM' },
	{ label: 'Owner / Proprietor', value: 'ZO' },
	{ label: 'Engineer', value: 'ZR' },
	{ label: 'Vice President', value: 'ZV' },
	{ label: 'Warehouse Manager', value: 'ZW' },
	{ label: 'Facilities Mgmt', value: 'ZX' }
];

export enum UserRoles {
  defaultUser = 'd345b32d-642e-45d9-a5dd-f273b1e2203b',
  admin = 'eeb8928f-3ca2-4388-9acb-411e043806e7',
};

export enum Icons {
  loaderWhite = 'assets/Loader2.gif',
  loaderOrange = 'assets/loader.gif',
  loaderWithoutForklift = 'assets/loaderWithoutFork.gif',
  raymondDownloadLoader = 'assets/raymondLoader.gif',
  rightArrowOrange = 'assets/arrowRightOrange.svg',
  arrowRight = 'assets/arrowRight.svg',
  leftArrow = 'assets/arrowLeft.svg',
  noResult = '/assets/noresults.svg',
  filter = '/assets/filter.svg',
  email = 'assets/Email.png',
  phone = 'assets/phone.png',
  location = 'assets/location.png',
  contact = 'assets/images/contact.png',
  storePartsPortalBanner = 'assets/Store_Parts_Portal_desktop.png',
  storePartsPortalBannerMobile = 'assets/Store_Parts_Portal_mobile.png',
  tayota360WarrantyPortal = 'assets/Warranty_Portal_Desktop.png',
  tayota360WarrantyPortalMobile = 'assets/Warranty_Portal_Mobile.png',
  unauthorized = '/assets/401_Unauthorized.png',
  pendingApproval = '/assets/Pending.png',
  userNotActivated = '/assets/User_not_activated.png',
  arrowDown = 'assets/arrowDown.svg',
  chevronDownDesk = 'assets/chevron-downDesk.svg',
  chevronDown = 'assets/chevron-down.svg',
  externalLink = 'assets/external_link.svg',
  externalLinkWhite = 'assets/external_link_white.svg',
  externalLinkOrange = 'assets/external_link_orange.svg',
  trash = 'assets/trash.svg',
  deleteDisabled = 'assets/deleteDisabled.svg',
  noMessage = 'assets/NoMessage.svg',
  closePng = 'assets/close.png',
  greenDot = 'assets/green_dot.svg',
  lightBlueDot = 'assets/light-blue-dot.svg',
  yellowDot = 'assets/yellow-dot.svg',
  redDot = 'assets/red-dot.svg',
  notificationoffer = 'assets/offer.svg',
  activeIcon = 'assets/updates.svg',
  actionIcon = 'assets/action.svg',
  raymondActionIcon = 'assets/images/action.svg',
  raymondUpdateIcon= 'assets/images/update.svg',
  notificationInbox= 'assets/images/notificationInbox.svg',
  moreIcon = '/assets/moreIcon.svg',
  moreIconDisabled = '/assets/moreIconDisabled.svg',
  desktopBanner = 'assets/desktopBanner.png',
  mobileBanner = 'assets/mobileBanner.png',
  userIcon = 'assets/userIcon.svg',
  equipmentIcon = 'assets/equipmentIcon.svg',
  noLocation = 'assets/unassignedLocation.svg',
  approveIcon = 'assets/approveIcon.svg',
  rejectIcon = '/assets/rejectIcon.svg',
  addLink = 'assets/addRole.svg',
  unreadNotifications = 'assets/unreadNotification.svg',
  trashIcon= 'assets/trashIcon.svg',
  trashDisabled = 'assets/trashDisabled.svg',
  accordionExpandedIcon = 'assets/accordion_expanded.svg',
  accordionCollapsedIcon = 'assets/accordion_collapsed.svg',
  toolTipCloseIcon = '/assets/tooltip-close-icon.svg',
  activeStatus = '/assets/status_active.svg',
  inActiveStatus = '/assets/status_inactive.svg',
  checkAcceptDisabled='/assets/check-accept-disabled.svg',
  closeRejectDisabled='/assets/close-reject-disabled.svg',
  editCompanyDetail='assets/edit.svg',
  editCompanyDetailDisabled='assets/editDisabled.svg',
  uploadFile='assets/uploadFile.svg',
  congratulations = 'assets/congratulations.svg',
  apiIssue='assets/apiIssue.svg',
  myInsightsLogo='assets/myInsightsLogo.svg',
  subscriptionInsightsLogo = 'assets/myInsights_plus_logo.png',
  subscriptionInsightsComplianceLogo = 'assets/myInsights_compliance.png',
  uploadLocationList='assets/uploadLocationList.svg',
  basicDevice='assets/basicDevice.svg',
  impactSensor = 'assets/impact_sensor.svg',
  uploadDisabled= 'assets/uploadDisabled.svg',
  dragDropIcon = 'assets/download.svg',
  dragDropIconRaymond ='assets/images/raymondDownloadIcon.svg',
  checkGreen = 'assets/checkGreen.svg',
  actionRed = 'assets/actionRed.svg',
  keyHours = 'assets/key-hours.svg',
  vehicleIcon = 'assets/vehicleMarker.svg',
  assignedLocationPin = 'assets/orangeMarker.svg',
  recenter = 'assets/recenter.svg',
  mapError = 'assets/mapErrorIcon.svg',
  noErrorCodes = 'assets/No_errorcodes_icon.svg',
  currentStatusIcon = 'assets/checkbox_forklift.png',
	greyLine= 'assets/grey_Rectangle.png',
	deliveredStatusIcon = 'assets/line_forklift.png',
	blueLine = 'assets/blue_rectangle.png',
	notDeliveredIcon = 'assets/forklift.png',
  noConnectedDevicesFound = '/assets/noConnectedDevicesFound.svg',
  chevronRightBlue = '/assets/chevron-right.svg',
  errorIcon = '/assets/errorIcon.svg',
  pdfIcon = '/assets/myservice_pdf.svg',
  wifiOrange = 'assets/Telematics.svg',
  wifigrey = 'assets/wifi_grey.svg',
  raymondRightArrow='/assets/images/raymond_right_arrow.svg',
  raymondMoreIcon='/assets/images/moreIconRaymond.svg',
  arrowDownRaymond = 'assets/images/arrowDownRaymond.svg',
  basicDeviceRaymond='assets/images/basicDeviceRaymond.svg',
  raymondApproveIcon = 'assets/images/raymond_approve_icon.svg',
  raymondConnectSerialNoIcon='/assets/images/connectedRedIcon.svg',
  filterRaymond='/assets/images/filter_raymond.svg',
  raymondUnreadNotifications = '/assets/images/raymond-notification-alert.svg',
  raymondLoader = '/assets/images/raymondLoader.gif',
  downloadButtonIconRaymond = '/assets/images/download.svg',
  downloadData = '/assets/download-data.svg',
  downloadDataDisabled = '/assets/download-data-disabled.svg',
  uploadBulkLocationEnabled = '/assets/upload_list_locations.svg',
  uploadBulkLocationDisabled = '/assets/upload_list_locations_disabled.svg',
  errorForkLift = '/assets/error-forklift.svg'
}
export enum AltText{
  editAdmingCompanyDetail='Edit Company Details',
  uploadFile='Upload File'
}
export enum BusinessAccountCategory{
  date='date',
  primary='primary',
  editData='editData',
  multiline='multiline',
  uploadFile='uploadFile',
  button='button'

}
export enum SuccessMessage {
  locationAccessUpdate = 'Location access request permission changed successfully.',
  locationLabelUpdate = 'Location label updated successfully',
  defaultViewUpdate = 'The default view has been configured to '
}

export enum ErrorMessage {
  newEquipmentNoDataTooltip = 'No equipment orders in specific status.',
  noLocations= 'You have not been assigned to any location.',
  approveUserErrorMsg = 'Server Error. Please try again.',
  fleetWidgetFailureError = 'Failed to load, please refresh the page.',
  unauthorizedError = '401 Unauthorized',
  saveUserError = 'Unfortunately we are having trouble connecting systems. Please try again.',
  commonError = 'Internal Server Error.',
  apiErrorMessage = 'Unfortunately, we are unable to process your request. Please try again or contact MyToyota Customer Service at customerservice@toyotatmh.com if the issue persists.',
  raymondApiErrorMessage= 'Unfortunately, we are unable to process your request. Please try again or contact Raymond Customer Service at customerfirst@raymondsupport.com if the issue persists.',
  fleetMoveEquipmentFleetManagedLocation = 'Toyota Material Handling Fleet Services manages this location. Please contact Toyota Customer Service to request your equipment to be moved to a new  location.',
  fleetMoveEquipmentAlreadyRequested = 'Equipment already has a pending request. Please check the VIN on the Change Requests table on the MyFleet page.',
  furtherActionsContactMessage='For further actions, please contact your admin at $token',
  productionSupport='API error, please contact production support team.',
  vinAlreadyExists='VIN/Equipment already exist.',
  vinExistsInAnotherLocation='VIN found at another location.',
  registration504Error = 'Sorry! We have encountered an issue on our side. Please try again. If the problem continues please contact Toyota Customer Service at customerservice@toyotatmh.com',
  lastTenErrorcodesEmptyData = 'There are currently no reported error codes on this equipment.',
  fleetaccountClassificationError='Sorry, an issue has occurred which requires your help. Please contact Toyota Customer Service to complete this action.',
  fleetToNonfleetError='Toyota Material Handling Fleet Services manages this location. Please contact Toyota Customer Service to request your equipment to be added to a new location.',
  noAssociatedResultsFoundText = 'No associated groups found',
  myinsightsDownloadError = 'Unable to download table due to connection error. Please try again later',
  userStatusUpdateError='We encountered an error. Please retry your action.',
  shippingListErrorMessage = 'Details not available at this time, Please return later',
  inviteUserBulkUploadApiFailure = 'An unexpected error occurred. Please try again later.',
  invalidEmailFormat = 'Invalid email format.',
  companyNotFoundError = 'Company not found',
  fleetWidgetFailureErrorRaymond = 'Failed to load, Please refresh the page.',
  downloadError = 'Download failed. Reduce the file size by applying a filter.',
  fleetMoveEquipmentAlreadyRequestedRaymond = 'A move request is already in progress for this truck and location. Please wait until it is completed.',
  fleetRemoveEquipmentAlreadyRequestRaymond = 'Equipment already has a pending remove request. Please check the Serial Number and location Id on the change request table.'
};

export enum WarningMessage {
  max40CharactersLimit = 'Maximum 40 characters allowed.',
}

export enum PermissionCategory {
  myFleet = 'FLEET_MAIN',
  equipmentDetails = 'EQUIPMENT_DETAILS',
  rolesPermissions = 'ROLES_PERMISSIONS',
  orderManagement = 'ORDER_MANAGEMENT',
  userManagement = 'USER_MANAGEMENT',
  serviceManagement = 'SERVICE_MANAGEMENT',
  dashBoard = 'DASHBOARD',
  finance = 'FINANCE',
  accountSettings = 'ACCOUNT_MANAGEMENT',
  locationManagement = 'LOCATION_MANAGEMENT',
  myQuote = 'MY_QUOTE',
  myInsights = 'MY_INSIGHTS_MAIN',
  notification = 'NOTIFICATION'
}
export enum PermissionDefault {
  viewDetails = 'VIEW_DETAILS',
  viewMyFleetDetails = 'VIEW_MYFLEET_DETAIL',
  viewOrderManagementPage = 'VIEW_ORDER_MNGMENT_PAGE',
  viewOrderDetailPage = 'VIEW_ORDER_DETAIL',
  viewUserManagement = 'VIEW_USER_MANAGEMENT_PAGE',
  viewUserDetail = 'USER_DETAILS_PAGE',
  viewApproveUser = 'VIEW_APPROVE_NEW_USER',
  viewServiceManagement = 'VIEW_SERVICE_CONTENT',
  viewDashboard = 'VIEW_DASHBOARD',
  viewFinance = 'VIEW_FINANCE_PAGE',
  viewAccountManagement = 'VIEW_OPT_ACCOUNT_SETTING',
  viewLocationManagement = 'VIEW_OPT_LOCATION_MANAGEMENT',
  viewLocationDetails = 'VIEW_LOCATION_DETAILS_PAGE_COMPANY_PROFILE',
  viewAddLocation = 'VIEW_OPT_ADD_NEW_LOCATION_PAGE',
  viewMyQuote = 'VIEW_OPT_MY_QUOTE',
  viewMyInsights = 'VIEW_MYINSIGHTS_MAIN',
  viewAddUser = 'ADD_NEW_USERS_PAGE',
  viewNotification = 'VIEW_OPT_MY_NOTIFICATION',
  viewDomainManagement = 'VIEW_DOMAIN_TAB',
}

export enum PermissionActions {
  buyParts = 'BUY_PARTS',
  serviceButton = 'REQUEST_SERVICE_BUTTON',
  viewOemTab = 'VIEW_OEM_TAB',
  viewMyInsights = 'VIEW_MYINSIGHTS_TAB',
  viewFinancing = 'VIEW_FINANCE_TAB',
  viewServicing = 'VIEW_SERVICE_TAB',
  orderDetailsLink = 'LINK_ORDER_DETAIL_ORDER',
  equipmentDetailsLink = 'LINK_EQUIP_DETAIL_ORDER',
  viewOrderManagementPage = 'VIEW_ORDER_MNGMENT_PAGE',
  moveRemoveEquipment = 'REMOVE_MOVE_EQUIPMENT',
  viewServiceManagement = 'VIEW_SERVICE_CONTENT',
  viewFilterServiceWidgets = 'VIEW_FILTER_WIDGET',
  viewServiceHistoryTable = 'VIEW_SERVICE_TABLE',
  viewServiceOrderDetails = 'VIEW_SERVICE_DETAIL',
  addMoveRemoveEquipment = 'ADD_REMOVE_MOVE_EQUIPMENT',
  linkToEquipmentDetails = 'LINK_TO_EQUIPMENT_DETAILS',
  userDetailLink = 'LINK_USER_DETAIL_PAGE',
  approveUserLink = 'LINK_APPROVE_USER_PAGE',
  serviceOrderLink = 'LINK_SERVICE_DETAILS_PAGE',
  viewFleetWidget = 'VIEW_FLEET_WIDGET',
  viewDealerWidget = 'VIEW_DEALER_WIDGET',
  viewEquipmentOrderWidget = 'VIEW_EQUIP_ORDER_WIDGET',
  serviceButtonDashboard = 'VIEW_SERVICE_BTN',
  viewOptDashbaord='VIEW_OPT_DASHBOARD',
  viewEquipmentOrderDetails='LINK_TO_EQUIP_ORDER_DETAILS',
  viewEquipmentDetailsDashboard='LINK_TO_EQUIP_DETAILS_DASHBOARD',
  viewProfileDetails='VIEW_PROFILE_ACCOUNT_SETTING',
  viewCompanyDetails='VIEW_COMPANY_PROFILE_ACCOUNT_SETTING',
  addRemoveButtonCompanyProfile = 'ADD_REMOVE_LOCATION_BTN_COMPANY_PROFILE',
  downloadBtnCompanyProfile = 'DOWNLOAD_BTN_COMPANY_PROFILE',
  linkToLocationDetails = 'LINK_TO_LOCATION_DETAILS_COMPANY_PROFILE',
  assignUsersLocationDetails = 'ASSIGN_USERS_BTN_LOCATION_DETAILS',
  downloadBtnLocationDetails = 'DOWNLOAD_BTN_LOCATION_DETAILS',
  removeLocationBtnLocationDetails = 'REMOVE_LOCATION_BTN_LOCATION_DETAILS',
  userProfileDisable = 'USER_PROFILE_DISABLE',
  addLocationDisable = 'ADD_LOCATION_DISABLE',
  disableAssignedLocationsEllipsis = 'ELLIPSES_DISABLE',
  disableRoleStatusDropdown = 'ROLE_STATUS_DROPDOWN_DISABLE',
  disableAssignUnassignLocation = 'ASSIGN_UNASSIGN_LOCATION_DISABLE',
  disableAssignLocationCheckbox = 'CHECKBOXES_DISABLE',
  disableSaveChangesBtn = 'SAVE_CHANGES_BUTTON_DISABLE',
  addUserButtonDisable = 'ADD_USER_BUTTON_DISABLE',
  serviceButtonDisable = 'SERVICE_BTN_DISABLE',
  addEquipmentEllipsisDisable = 'ADD_EQUIP_ELLIPSES_DISABLE',
  contactFormDisable = 'CONTACT_FORM_DISABLE',
  buyPartsReqServiceDisable = 'BUY_PARTS_REQ_SERVICE_DISABLE',
  moveRemoveEquipDisable = 'REMOVE_MOVE_EQUIP_DISABLE',
  requestServiceBtnDisable = 'REQUEST_SERVICE_BUTTON_DISABLE',
  approveRejectBtnDisable = 'APPROVAL_REJECTION_BUTTON_DISABLE',
  accessTableDropdownCheckboxDisable = 'DROPDOWN_CHECKBOXES_ACCESS_TABLE_DISABLE',
  userlistStatusDropdownDisable = 'STATUS_DROPDOWN_DISABLE',
  viewDomain = 'VIEW_DOMAIN_TAB',
  viewEditDomain = 'MODIFY_DOMAIN_INFO',
  viewAddDomain = 'ASSIGN_DOMAIN',
  viewToggleLocation = 'TOGGLE_LOCATION_PERMISSIONS_BTN',
  viewAddLocationModal = 'ASSIGN_LOCATION_PERMISSIONS_BTN',
  disableToggleLocation = 'TOGGLE_LOCATION_PERMISSIONS_BTN_DISABLE',
  manageSubscription = 'MANAGE_MYINSIGHTS_SUBSCRIPTIONS',
  disableManageSubscription = 'MANAGE_MYINSIGHTS_SUBSCRIPTIONS_DISABLE',
  acessMyInsightsPortal = 'ACCESS_MYINSIGHTS_PORTAL',
  hasActiveSubscription = 'HAS_ACTIVE_SUBSCRIPTION'
}

export enum DefaultValue {
  skip = 0,
  limit = 50,
  notificationLimit = 7
}

export enum FieldName {
  email = 'email',
  serviceDate = 'serviceDate',
  workOrderNumber = 'workOrderNumber',
  cost = 'cost',
  status = 'status',
  invoiceNumber = 'invoiceNumber',
  name = 'name',
  vin = 'vin',
  lastLogin = 'lastLogin',
  orderNumber = 'orderNumber',
  truckNumber = 'truckNumber',
  equipmentVin = 'equipmentVin',
  orderDate = 'orderDate',
  eta = 'ETA',
  dueDate = 'dueDate',
  locationAddress = 'locationAddress',
  assignedLocations = 'assignedLocations',
  id = 'id',
  userId= 'userId',
  customerId = 'customerId',
  location = 'location',
  crmOppNumber = 'crmOppNumber',
  assignedLocation = 'assignedLocation',
  equipmentType = 'equipmentType',
  manufacturer = 'manufacturer',
  locationId='locationID',
  modelID='modelID',
  assetNumber='assetNumber',
  dateOfFirstUse='dateOfFirstUse',
  changeRequestId='changeRequestID',
  date='date',
  telematicsStatus = 'telematicsStatus',
  lastTimestamp = 'lastTimestamp',
  billingAddress='billingAddress',
  dealership='dealership',
  quoteId='quoteId',
  billingLocationAddress = 'billingAddress',
  shippingLocationAddress = 'shippingAddress',
  dashboardBillingLocationAddress = 'billingLocationAddress',
  dashboardShippingLocationAddress = 'shippingLocationAddress',
  billingLocation = 'billingLocation',
  shippingLocation = 'shippingLocation',
  model = 'model',
  equipmentStatus = 'Status',
  creationDate='creationDate',
  keyHours = 'keyHours',
  averageUtilization = 'averageUtilization',
  totalImpact = 'totalImpact',
  batteryStateOfCharge = 'batteryStateOfCharge',
  role = 'role',
  subscriptionName = 'subscriptionName',
  operatorHour = 'operatorHours',
  endDate = 'endDate',
  time = 'time',
  invoiceAmount = 'invoiceAmount',
  asset = 'asset',
  subscriptionPlan = 'subscriptionPlan',
  subscriptionTerm = 'subscriptionTerm',
  primarySubLocation = 'primarySubLocation',
  action = 'action',
  locationLabel = 'locationLabel',
  equipmentAddress = 'equipmentAddress',
  equipmentLocation = 'equipmentLocation',
  effectiveDate = 'effectiveDate',
  subscriptionId = 'subscriptionId',
  renewalDateString = 'renewalDateString',
  autoRenew = 'autoRenew',
  primarySubscriptionAddress = 'primarySubscriptionAddress'


}
export enum OrderStatusHeader {
  pastDue = 'pastDue',
  open = 'open',
  upcoming = 'upcoming',
  paid = 'paid',
  all = 'all'
}

export enum ToolTipMessages {
  dashboardOpenQuotesTooltip = 'Includes both Ready for Review and In Process quotes.',
  dashboardActiveEquipmentOrdersTooltip = 'Includes both In Process and In Production orders.',

}
export const assignedHeaders= [ 'Name', 'Email', 'Role', 'Job Title', 'Status' ];
export enum BreadCrumb {
  addNewLocation = 'Add New Location',
  locationDetails = 'Location Details',
  addNewDomain = 'Add New Domain',
  editDomain = 'Edit Domain'
}

export enum FleetListTabHeader{
  fleetList = 'Fleet List',
  changeRequest = 'Change Request'
}

export enum CompanyLocationsTableHeader {
    locationName =  'Location Name',
		address =  'Address',
    country = 'Country',
		assignedUsers =  'Assigned Users',
		equipmentCount =  'Equipment'
}
export enum CompanyLocationsTableHeaderNonAdmin {
    locationName =  'Location Name',
		address =  'Address',
    country = 'Country',
		equipmentCount =  'Equipment'
}
export enum AssignedUserTableHeader {
    name =  'Name',
		email =  'Email',
		role =  'Role',
		jobTitle =  'Job Title',
		status =  'Status'
}
export enum BulkEquipmentHeader {
  model = 'Model',
  serial =  'Serial',
  make =  'Make',
  currentlocation =  'Current Location',
  targetLocation =  'Target Location',
  status =  'Status'
}

export enum BulkEquipmentHeaderRaymond {
  model = 'Model',
  serial =  'Serial Number',
  make =  'Make',
  currentlocation =  'Current Location',
  targetLocation =  'Target Location',
  status =  'Status',
  message = 'Message'
}

export enum ReviewListDownloadHeaderRaymond {
  model = 'Model',
  serial =  'Serial Number',
  make =  'Make',
  location = 'Equipment Location',
  reason = 'Reason',
  status =  'Status',
  message = 'Message'
}
export enum ReviewListDownloadHeader {
  vin = 'VIN',
  model = 'Model Number',
  asset = 'Asset',
  equipmentLocation = 'Equipment Location',
  dateOfFirstUse = 'Date of First Use',
  status =  'Status',
  additionalInformation = 'Additional Information',

}

export enum AddBulkEquipmentDownloadReportTemplate {
  model = 'Model',
  serial = 'Serial',
  location = 'Location ID',
  status = 'Status',
  additionalInformation = 'Additional Information',
}
export enum AddBulkEquipmentNonToyotaDownloadReportTemplate {
  model = 'Model',
  serial = 'Serial',
  location = 'Location ID',
  make = 'Make',
  makeYear = 'Make Year',
  equipmentClassification = 'Equipment Classification',
  status = 'Status',
  additionalInformation = 'Additional Information',
}
export enum AddBulkEquipmentNonRaymondDownloadReportTemplate {
  model = 'Model',
  serial = 'Serial',
  location = 'Location ID',
  make = 'Make',
  makeYear = 'Make Year',
  status = 'Status',
  additionalInformation = 'Additional Information',
}
export enum RemoveBulkEquipmentHeader {
  model = 'Model',
  serial =  'Serial',
  make =  'Make',
  reason = 'Reason',
  status =  'Status',
  message = 'Message'
}
export enum UseVerifiedOrEditAddress {
  useVerifiedAddress = 'Use Verified Address',
  editAddress = 'Edit Address',
  cssClass = 'confirmVerifiedAddress',
  label = 'Verify Your Address'
}

export enum ChangeVerifyRole {
  label = 'Proceed as Company Admin?'
}
export enum PortalRole {
  companyAdmin = 'Company Admin'
}
export enum ModalButtonId {
  agree = '3311f022-ae28-4fe6-a0ee-9163b05e2547',
  cancel = '74d837c6-b5c4-40e5-a91f-5aee33dbdafa',
  proceed = '6cb83409-79b9-480e-993a-ad792ca353bd',
  save = 'b2d709e2-56ef-48d0-9ba1-b8968de92c36',
  removeLocation = '82de5a0f-2963-4e89-9727-72596cabca2c',
  manageFleet = 'bd505b2d-0ceb-4492-b97b-849f1836d168',
  close = 'fb5f3cbe-5163-11ee-be56-0242ac120002'
}
export enum MyFleetTableLabels {
  equipmentVin = 'equipmentVin',
  modelID = 'modelID',
  assetNumber = 'assetNumber',
  equipmentType = 'equipmentType',
  manufacturer = 'make',
  dateOfFirstUse = 'dateOfFirstUse',
  assignedLocation = 'assignedLocation',
  telematicsStatus = 'telematicsStatus',
  fleetType = 'fleetType',
  serialNumber = 'serialNumber',
  lastKnownLocation = 'lastKnownLocation'
}

export enum RaymondMyFleetTableLabels {
  equipmentVin = 'equipmentVin',
  unit = 'unit',
  assetNumber = 'assetNumber',
  assignedLocation = 'assignedLocation',
  ownershipType='ownershipType',
  manufacturer = 'manufacturer',
  dateOfFirstUse = 'dateOfFirstUse',
  equipmentStatus='equipmentStatus',
  telematicsStatus = 'telematicsStatus'
}
export enum TermsAndPrivacy {
  termsAndConditions = 'Terms & Conditions of Use',
  privacyPolicy = 'Privacy Policy'
}
export enum RegistrationStatus {
  approved = 'approved',
  inProgress = 'in_progress'
}
export enum RegistrationRequestType {
  businessAdminUser = 'BUSINESS_ADMIN_USER'
}
export const serviceCampaignClass = 'service-campaign-link';

export enum ApplicationPath{
  authentication = '/auth',
  dashboard = '/app/dashboard',
  myFleet = '/app/myfleet',
  connectedSolution = '/app/my-insights',
  orderManagement = '/app/order-management',
  serviceManagement = '/app/service-management',
  userManagement = '/app/user-management',
  userManagementApprove = '/app/user-management/approve',
  userManagementAddUser = '/app/user-management/adduser',
  accountSettingsCompany = '/app/location-management',
  accountSettingsLocation = '/app/location-management/location',
  accountSettingsAddLocation = '/app/location-management/add-new-location',
  accountSettingsDomain = '/app/account-settings/domain',
  accountSettingsAddDomain = '/app/account-settings/add-domain',
  accountSettingsEditDomain = '/app/account-settings/edit-domain',
  subscriptionOverview = 'app/my-insights/subscription-management',
  subscriptionAddress = 'app/my-insights/subscription-management/address',
  authError = '/app/error',
  unAuthError = '/error',
  confirmation = '/confirmation',
  pendingBusinessApproval = '/pending-approval',
  customerportal='/customerportal',
  businessAccountRequest = '/businessaccountrequest',
  customerSupport = '/customer-support',
  cancelBulkSubscription = 'app/my-insights/subscription-management/cancel-renewal'
}

export enum EcomPath {
  subscriptionAddressPath = '/en/update-subscription-address',
  buySubscriptionPath = '/en/connected-solution',
  viewInvoiceHistoryPath = '/en/account-dashboard/order-history/subscription-order',
  subscriptionPaymentPath = '/en/update-subscription-payment'
}

export enum HeaderStateField {
  serviceDate = 'Service Date',
  dateOfFirstUse ='Date of First Use',
  orderDate = 'Order Date',
  name = 'Name',
  cost = 'Cost',
  paymentStatus = 'Payment Status',
  invoiceNumber = 'Invoice',
  date = 'Date',
  telematicsStatus = 'Connected',
  orderNumber = 'Order #'
}

export enum ButtonSize {
  small = 'small',
  medium = 'medium',
  large = 'large'
}

export enum ButtonStyle {
  primary= 'primary',
  secondary = 'secondary',
  destructive = 'destructive',
  secDestruct = 'secondary-destructive',
  tertiary = 'tertiary',
  link = 'link',
  linkPrimary = 'link-primary'
}

export enum ButtonPosition {
  left = 'left',
  right = 'right',
  none = 'none'
}

export enum FormattingName {
  companyName = 'companyName',
  addressOne = 'addressLine1',
  addressTwo = 'addressLine2',
  city = 'city',
  accountName = 'accountName'
}

export enum ChangeRequestType {
  add = 'add',
  move = 'move',
  remove = 'remove'
}
export enum UserType {
  generalUser = 'GENERAL_USER',
  individualUser = 'INDIVIDUAL_USER',
  businessAdminUser = 'BUSINESS_ADMIN_USER'
}

export enum MyFleetTelematicsStatus {
  active = 'Active',
  connected = 'connected',
  notConnected = 'Not Connected',
  notConnectedCamleCase = 'notConnected',
  notConnectedWithoutSpace = 'NotConnected',
  null = 'null',
  downloadNull = 'Unable to retrieve information'
}
export enum MyQuotesStatusHeader {
  all = 'all',
  quoteinProcess = 'quoteinProcess',
  quoteAccepted = 'quoteAccepted',
  ordered = 'ordered',
  expired = 'expired',
  readyForReview = 'readyForReview'
}
export enum MyFleetStatusHeader {
  all = 'all',
  awaitingApproval = 'awaiting approval',
  cancelled = 'cancelled',
  approved = 'approved',
}
export enum EllipsisOptions {
  editLocationLabel = 'Edit Location Label',
  makePrimaryLocation = 'Make Primary Location',
  removeLocation = 'Remove Location'
}

export enum ApiResponseStatus{
  success='success',
  error='error'
}
export enum MyInsightsAccordionType {
  helpGuide = 'MyInsights Help Guide',
  telematicsDocumentation = 'MyInsights Telematics Legal Documentation'
}
export enum SubscriptionType {
  desktop = 'subscriptionsDesktop',
  mobile = 'subscriptionsMobile'
}
export enum SubscriptionFileType {
  allSubscriptionList = 'allSubscriptionList',
  subscriptionAddressList = 'subscriptionAddressList'
}
export enum IsRequestSubmittedForReview {
  isRequestSubmittedForReview = 'isRequestSubmittedForReview'
}

export enum BooleanValues {
  true = 'true',
  false = 'false'
}

export enum IdleUserTimes {
  idleTime = 600000,
  countdownTime = 5000
}

export enum MaxDeviceWidth {
  mobile = 768,
}

export const skipAuthUrls = ['/contact-us'];

export const skipRaymondAuthUrls = ['/content-page'];

export enum InviteUserheader {
  id = 'Id',
  email =  'Email',
  phoneNumber = 'PhoneNumber',
  firstName = 'FirstName',
  lastName = 'LastName',
  jobTitleDescription = 'JobTitleDescription',
  jobTitle =  'Job Title',
  roleName =  'RoleName',
  roles =  'Roles',
  company =  'Company',
  portalApprovedCustomerID =  'PortalApprovedCustomerID',
  contactID =  'ContactID',
  tcDate =  'TcDate',
  privacyDate =  'PrivacyDate',
  portalApproveUserDate =  'PortalApproveUserDate',
  userStatus =  'UserStatus',
  lastLogin = 'Last Login',
  portalApprovedCustomerIDCount = 'Portal Approved CustomerID Count',
  name =  'Name',
  rootLocationGRID = 'RootLocationGRID',
  primaryLocationGRID = 'PrimaryLocationGRID',
  adminLocationID = 'AdminLocationID',
  topLevelGrid = 'TopLevelGrid',
  isBusinessAccount = 'IsBusinessAccount',
  userStatusUpdateState = 'UserStatusUpdateState',
  active = 'Active',
  success = 'Success',
  errors = 'Errors',
}

export enum InviteBulkUserheader {
  email =  'Email ID',
  firstName = 'FirstName',
  lastName = 'LastName',
  phoneNumber = 'PhoneNumber',
  roleName =  'Role Name',
  jobTitle =  'Job Title',
  locationId =  'Location ID',
  isValid = 'IsValid',
  sendEmailInvite = 'Send Email Invite',
  errors = 'Errors'
}

export enum InviteUserheaderRaymond {
  id = 'Id',
  email =  'Email',
  phoneNumber = 'PhoneNumber',
  firstName = 'FirstName',
  lastName = 'LastName',
  jobTitleDescription = 'JobTitleDescription',
  jobTitle =  'Job Title',
  roleName =  'RoleName',
  roles =  'Roles',
  company =  'Company',
  portalApprovedCustomerID =  'PortalApprovedCustomerID',
  tcDate =  'TcDate',
  privacyDate =  'PrivacyDate',
  portalApproveUserDate =  'PortalApproveUserDate',
  userStatus =  'UserStatus',
  lastLogin = 'Last Login',
  portalApprovedCustomerIDCount = 'Portal Approved CustomerID Count',
  name =  'Name',
  rootLocationGRID = 'RootLocationGRID',
  primaryLocationGRID = 'PrimaryLocationGRID',
  adminLocationID = 'AdminLocationID',
  topLevelGrid = 'TopLevelGrid',
  isBusinessAccount = 'IsBusinessAccount',
  userStatusUpdateState = 'UserStatusUpdateState',
  active = 'Active',
  success = 'Success',
  errors = 'Errors',
}

export enum DashboardCardTooltip {
  openQuotes = 'Open Quotes',
  activeEquipmentOrders = 'Active Equipment Orders',
}
export enum ByParts {
  buyParts = 'Buy Parts',
}

export enum VerifyEquipmentCodes {
  equipmentNotFound = 'EQUIPMENT_NOT_FOUND',
  equipmentVerified = 'EQUIPMENT_VERIFIED',
  equipmentAlreadyExist = 'EQUIPMENT_ALREADY_EXISTS',
  equipmentAtAnotherLocation = 'EQUIPMENT_FOUND_AT_DIFFERENT_LOCATION',
  nonToyotoequipmentVerified = 'ADD_NON_TOYOTA_EQUIPMENT',
  issueType = 'TOYOTA_EQUIPMENT_NOT_FOUND',
  equipmentAtAnotherCompany = 'EQUIPMENT_FOUND_AT_DIFFERENT_COMPANY'
}

export enum UserDetailsConstant {
  location = 'location',
  address = 'address',
  locationid = 'locationid',
  checked = 'checked',
  disable = 'disable',
  companyAdminRole = 'Company Admin',
  statusInactive = 'inactive',
  statusActive = 'active',
  updateValue = 'updateValue',
  assigned = 'Assigned',
  unassigned = 'Unassigned',
  name = 'Name',
  updatedRole = 'Updated Role',
  updatedStatus = 'Updated Status',
  submit = 'Submit',
  changed = 'changed'

}

export enum UserFilterConstants {
  allLocation = 'all',
  assignedLocation = 'assigned',
  unassignedLocation = 'unassigned'
}

export enum DropDownOption {
  all = 'all',
  fleet = 'Fleet',
  self = 'self',
  customer = 'Customer'
}

export const months = [
	'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
];
export enum DownloadNote {
  en = 'Downloading ...',
  fr = 'Téléchargement...'
}

export enum TermsAndConditionPrivacyPolicyInfoBannerText{
   tandCInfoBannerText = 'Please scroll through and read the Terms & Conditions of Use, then agree to them by checking the box to continue using the MyToyota Portal',
   privacyPolicyInfoBannerText = 'Please scroll through and read the Privacy Policy, then agree to them by checking the box to continue using the MyToyota Portal'
}

export enum ImpactIntensity{
  critical = 'Critical',
  high = 'High',
  medium = 'Medium',
  low= 'Low'
}

export enum MyInsightsStatusLabel {
  all = 'All',
  noSubscription = 'No Subscription',
  myInsights = 'MyInsights Plus',
  myInsightsCompliance = 'MyInsights Plus Compliance'
}

export enum MyInsightsStatusHeader {
  all = 'all',
  noSubscription = 'NoSubscription',
  myInsights = 'MyInsightsPlus',
  myInsightsCompliance = 'MyInsightsCompliance'
}

export enum CardListTableHeader {
  subscriptionPlan = 'Subscription Plan',
  assignedLocation = 'Assigned Location'
}

export enum SubOverviewHeader {
  primarySubAddress = 'Primary Subscription Address',
  equipmentLocation = 'Equipment Location'
}

export enum ReasonType {
  other = 'Other'
}
export enum ReasonLabel {
  other = 'Other'
}

export enum ManageSubscription {
  upgrade = 'Upgrade',
  downgrade = 'Downgrade',
  updateAddress = 'Update Subscription Address',
  updatePayment = 'Update Payment Method',
  cancelRenewal = 'Cancel Renewal',
  vin = 'vin'
}

export enum ChartId {
  emptyMessage = 'emptyMessage'
}

export enum DateFilterType {
  last = 'last',
  next = 'next'
}

export enum PageDetails {
  perPageLimit = 50
}

export enum ApplicationPathRaymond{
 analyticsReporting = '/app/analytics-reporting'
}

export const analyticsReporting = {
	totalCost: { page: 'total-costs' },
	utilization: { page: 'utilization' },
	fleetAdvisor: { page: 'fleet-advisor' },
	operatorAnalytics: { page: 'operator-analytics' },
	poBalance: { page: 'po-balance' }
} as const;

